import { qsa, qs, listen, add, remove } from '@fluorescent/dom';

const selectors = {
  slider: '[data-slider]',
  prev: '[data-prev]',
  next: '[data-next]',
};

export default (node, opts = {}) => {
  const sliderElement = qs(selectors.slider, node);
  const previousButton = qs(selectors.prev, node);
  const nextButton = qs(selectors.next, node);

  const defaultOpts = {
    adaptiveHeight: !window.matchMedia('(min-width: 45em)').matches,
    cellAlign: 'left',
    cellSelector: '[data-slide]',
    pageDots: false,
    prevNextButtons: false,
    contain: true,
    imagesLoaded: true,
    pauseAutoPlayOnHover: !window.Shopify.designMode,
    on: {
      ready: function () {
        _updateNavigationPosition();
      },
    },
  };

  const config = Object.assign({}, defaultOpts, opts);

  if (!config.wrapAround) {
    previousButton.disabled = true;
  }

  const _updateNavigationPosition = () => {
    const firstImage = qs('.image__img, .placeholder-image', node);
    const firstImageHeight = firstImage.clientHeight;
    const buttonHeight = nextButton.clientHeight;

    const offset = firstImageHeight / 2 - buttonHeight / 2;

    nextButton.style.top = `${offset}px`;
    previousButton.style.top = `${offset}px`;

    remove(nextButton, 'hidden');
    remove(previousButton, 'hidden');
  };


  import('flickity').then(({ default: Flickity }) => {
    const slider = new Flickity(sliderElement, config);

    if (!config.wrapAround) {
      slider.on('scroll', progress => {
        const progressScale = progress * 100;

        // https://github.com/metafizzy/flickity/issues/289
        previousButton.disabled = progressScale < 1;
        nextButton.disabled = progressScale > 99;
      });
    }

    // Account for page-transition links that can fire on flickity drag
    slider.on('dragStart', () =>
      slider.slider.childNodes.forEach(slide =>
        qsa('a[href]', slide).forEach(element => add(element, 'no-transition'))
      )
    );
    slider.on('dragEnd', () =>
      setTimeout(() => {
        slider.slider.childNodes.forEach(slide =>
          qsa('a[href]', slide).forEach(element =>
            remove(element, 'no-transition')
          )
        );
      }, 100)
    );

    const prevClick = listen(previousButton, 'click', () => slider.previous());
    const nextClick = listen(nextButton, 'click', () => slider.next());

    return {
      destroy: () => {
        if ((slider.slides || {}).length > 1) {
          prevClick();
          nextClick();
        }
        slider.destroy();
      },
      select: index => slider.select(index),
    };
  });
};
